module.exports = __webpack_public_path__ + "img/users-solid.e8b0ffd.svg";